import React from "react";

function MapSection() {
  return (
    <div className="map-con">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.4717875971583!2d78.4000489!3d17.437118899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9145cbeefaef%3A0xb703be0532d8c078!2sMohans%20Plaza!5e0!3m2!1sen!2sin!4v1779779387801!5m2!1sen!2sin"
        style={{ border: "none", width: "100%", height: "450px" }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Mohans Plaza Location"
      ></iframe>
    </div>
  );
}

export default MapSection;